
window._event_token = Math.random().toString(36).substring(2);
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import DefaultLayout from '@/layouts/Default'
import AuthLayout from '@/layouts/Auth'
import OneColumnLayout from '@/layouts/OneColumn'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import 'moment/locale/pl'
import IntersectionPolyfill from 'intersection-observer';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';
import panZoom from 'vue-panzoom';

// install plugin
Vue.use(panZoom);

/* eslint-disable */
import Pusher from 'pusher-js'
/* eslint-enable */
import VueEcho from 'vue-echo';

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.component('default-layout', DefaultLayout);
Vue.component('auth-layout', AuthLayout);
Vue.component('one-column-layout', OneColumnLayout);
const VueCookie = require('vue-cookie');

import axios from './plugins/axiosInterceptor'
window.axios = axios;
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(VueCookie);
Vue.use(VueVirtualScroller);
Vue.use(VueCroppie);
Vue.use(IntersectionPolyfill);


import VueMoment from 'vue-moment';
const moment = require('moment')
require('moment/locale/pl')
Vue.use(VueMoment, {
  moment
});

window.Pusher = require("pusher-js");

Vue.use(VueEcho, {
	broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_KEY,
	api_key: process.env.VUE_APP_PUSHER_KEY,
	cluster: "eu",
	app_id: process.env.VUE_APP_PUSHER_APP_ID,
	forceTLS: true,
	// encrypted: false,
	authorizer: (channel) => {
		return {
			authorize: (socketId, callback) => {
				axios.post('broadcasting/auth', {
						socket_id: socketId,
						channel_name: channel.name,
				}).then((response) => {
					callback(false, response.data);
				})
				.catch((error) => {
					console.log("ECHO", error.response)
					callback(true, error);
				});
			},
		}
	},
});

Vue.use(VuePlyr, {
	plyr: {}
})

Vue.prototype.$snackbar = {
	notification: (data) => {
		store.commit('application/showSnackbar', {type: 'notification', data: data});
	},
	error: (data) => {
		store.commit('application/showSnackbar', {type: 'error', data: data});
	},
	success: (data) => {
		store.commit('application/showSnackbar', {type: 'success', data: data});
	},
};



Vue.prototype.$throwError = (error) => {
	store.commit('application/throwError', error)
}

Vue.prototype.$notificationUrl = (n) => {
	let url = {
		name: 'Post',
		params: {
			id: n.post_id
		},
		query: {
			ref: 'notification',
			notification_id: n.id,
			notification_type: n.type
		}
	};
	if(n.type == 'comment_added' || n.type == 'comment_updated') {
		if(n.what) {
			url.name = 'Comment';
			url.params.id = n.what.id
		}
		else {
			return null;
		}

	}
	if(n.what && n.what.type == 'reaction') {
		url.query.reaction_id = n.what.id;
		if(n.where) {
			if(n.where.type == 'post') {
				url.name = 'Post';
				url.params.id = n.post_id;
			}
			if(n.where.type == 'comment') {
				url.name = 'Comment';
				url.params.id = n.where.id;
			}
			if(n.where.type == 'problemIdea') {
				url.name = 'Post';
				url.params.id = n.post_id;
				url.query.tab = 'ideas'
			}
		}
	}
	if(n.what && n.what.type == 'task') {
		url.query.task_id = n.what.id;
		url.name = 'Tasks';
		url.params.id = n.what.id;
	}


	return url;
}

new Vue({
	data: {
		appName: process.env.VUE_APP_NAME || "Leanovatica SOU",
	},
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
